import { STORES_API } from 'modules/stores/api/stores-api'
import {
  StoreCreateInterface,
  StoreId,
  StoreInterface,
  StoreUpdateInterface,
} from 'modules/stores/types/stores-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'

export const useStoresApi = () => {
  const { fetcher: postFetcher } = useFetch<RequestMethodsEnum.post, StoreInterface>({
    method: RequestMethodsEnum.post,
    unprocessableContentHandler: error => {
      throw error
    },
  })

  const { fetcher: putFetcher } = useFetch<RequestMethodsEnum.put, StoreInterface>({
    method: RequestMethodsEnum.put,
    unprocessableContentHandler: error => {
      throw error
    },
  })

  const { fetcher: deleteFetcher } = useFetch({
    method: RequestMethodsEnum.delete,
  })
  const createStore = (data: StoreCreateInterface) => postFetcher(STORES_API, data)
  const updateStore = (id: StoreId, data: StoreUpdateInterface) =>
    putFetcher(`${STORES_API}/${id}`, data)
  const deleteStore = (id: StoreId) => deleteFetcher(`${STORES_API}/${id}`)

  const updateStoreDesign = (id: StoreId, data: Pick<StoreInterface, 'design'>) =>
    putFetcher(`${STORES_API}/${id}/design`, data)

  return { createStore, updateStore, deleteStore, updateStoreDesign }
}
